<template>
    <v-dialog persistent  v-model="dialog" max-width="500">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>Cancelar Cita</v-toolbar-title>
                <v-spacer></v-spacer>
                    <v-btn icon dark @click="hide">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-layout wrap align-center justify-center>
                        <v-flex xs12  text-center>
                            <v-select label="Seleccione el motivo" fillled v-model="reason" :items="baseReasons"></v-select>
                        </v-flex>
                        <v-slide-y-transition>
                            <v-flex v-show="reason === 'other'" xs12  text-center>
                                <v-textarea label="Describa el motivo" fillled v-model="customReason" :rules="rules"/>
                            </v-flex>
                        </v-slide-y-transition>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" rounded :disabled="!valid" color="primary" depressed @click="confirmCancel">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import {getLabel} from '@/utils/Institution'

    import {mapMutations} from 'vuex'
    import AppointmentsMixin from "@/mixins/AppointmentsMixin";

    export default{
        props: {
          forClient: {
            type: Boolean,
            default: false,
          }
        },
        mixins: [AppointmentsMixin],
        data(){
            return {
                dialog: false,
                other: false,
                reason: '',
                customReason: '',
                appointmentId: null,
                loading: false,
                rules: [
                        v => !!v || 'Este campo es obligatorio',
                        v => v.length > 10 || 'Requiere al menos 10 caracteres',
                ]
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            getLabel,
            show(appointmentId){
                this.appointmentId = appointmentId
                this.dialog = true
            },
            hide(){
                this.dialog = false
            },
          async confirmCancel(){
            const vm = this

            if(vm.loading) return

            vm.loading = true
            const reason = vm.reason !== 'other' ? vm.reason : vm.customReason
            const cancelResponse = await vm.cancelAppointment(vm.appointmentId, reason)
            vm.loading = false

            if(!cancelResponse){
              vm.showSnackBar('Ha ocurrido un error intentando cancelar la cita')
              return vm.$emit('error')
            }

            vm.showSnackBar('La cita ha sido cancelada')
            vm.$emit('success', cancelResponse)
            vm.hide()

          }
        },
        computed: {
            valid(){
                var vm = this
                return ((vm.reason && vm.reason !== 'other') || (vm.customReason && vm.reason === 'other'))
            },
            baseReasons(){
                const vm = this
                const anotherPlace = vm.forClient ? 'Agendé en otro lugar'
                    : `El ${getLabel('commons.client.singular').toLowerCase()} encontró hora en otro centro`

                const couldNotReach = vm.forClient ? 'No pude contactarme'
                    : `No se pudo contactar al ${getLabel('commons.client.singular').toLowerCase()}`

                return [
                    {
                        text: anotherPlace,
                        value: 'another_institution'
                    },
                    {
                        text: couldNotReach,
                        value: 'cant_contact_client'
                    },
                    {
                        text: `Otro`,
                        value: 'other'
                    },
                ]
            }
        },
        watch:{
            reason(val){}
        }

    }
</script>
